import '../shared';
import './components';
import injectShareThis from '../../auto/utils/injectShareThis';
import Carousel from '../../auto/carousel';

window.injectShareThis = injectShareThis;
window.Carousel = Carousel;

document.addEventListener('DOMContentLoaded', () => {
  // eslint-disable-next-line no-new
  new Carousel('.slide', {
    autoplay: {
      delay: 5000,
    },
    speed: 500,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  });
});
